var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowseicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.623 6.69701L7.49629 12.8237C6.74572 13.5742 5.72774 13.9959 4.66629 13.9959C3.60483 13.9959 2.58685 13.5742 1.83629 12.8237C1.08572 12.0731 0.664063 11.0551 0.664062 9.99368C0.664063 8.93222 1.08572 7.91424 1.83629 7.16368L7.54962 1.45034C8.05 0.949086 8.729 0.66713 9.43726 0.666505C10.1455 0.66588 10.825 0.946636 11.3263 1.44701C11.8275 1.94739 12.1095 2.62639 12.1101 3.33465C12.1108 4.04292 11.83 4.72242 11.3296 5.22368L5.60295 10.937C5.35277 11.1872 5.01344 11.3278 4.65962 11.3278C4.3058 11.3278 3.96647 11.1872 3.71629 10.937C3.4661 10.6868 3.32555 10.3475 3.32555 9.99368C3.32555 9.63986 3.4661 9.30053 3.71629 9.05035L9.37629 3.39701",
    stroke: "#1A1A1A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseicon);
export default __webpack_public_path__ + "static/media/Browse icon.75971920a15a438c03f4d81849346d7e.svg";
export { ForwardRef as ReactComponent };